"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const icons_1 = require("../../../../assets/icons");
const images_1 = require("../../../../assets/images");
const components_1 = require("../../../../components");
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const constants_1 = require("../../../../constants");
const rootNavigation_1 = require("../../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../../navigators/Routes"));
const scale_1 = require("../../../../utils/scale");
const ArticleInfo = (props) => {
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const { isArticle, data } = props;
    const [isCollapse, setCollapse] = (0, react_1.useState)(false);
    const [bodyHeight, setBodyHeight] = (0, react_1.useState)((0, scale_1.scale)(160));
    const translateY = (0, react_1.useRef)(new react_native_1.Animated.Value(isCollapse ? 0 : 1)).current;
    (0, react_1.useEffect)(() => {
        if (!isCollapse) {
            react_native_1.Animated.timing(translateY, {
                toValue: 1,
                duration: 300,
                useNativeDriver: false,
            }).start();
        }
    }, [isCollapse]);
    const toggleCollapseView = () => {
        react_native_1.Animated.timing(translateY, {
            toValue: isCollapse ? 1 : 0,
            duration: 300,
            useNativeDriver: false,
        }).start();
        setCollapse(!isCollapse);
    };
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: data?.user_handle || ''
            }
        });
    };
    return (react_1.default.createElement(react_native_1.Animated.View, { style: [
            styles.box,
            {
                paddingBottom: insets.bottom + (0, scale_1.scale)(8),
                bottom: translateY.interpolate({
                    inputRange: [0, 1],
                    outputRange: [-bodyHeight, 0],
                })
            }
        ] },
        react_1.default.createElement(react_native_1.View, { style: styles.header },
            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, weight: "600", style: styles.headerTitle }, isArticle ? '選択された記事' : '選択された自分史'),
            react_1.default.createElement(react_native_1.Pressable, { onPress: toggleCollapseView }, isCollapse ? react_1.default.createElement(icons_1.IC_MINDMAP_UP, null) : react_1.default.createElement(icons_1.IC_MINDMAP_DOWN, null))),
        react_1.default.createElement(react_native_1.View, { style: styles.body },
            react_1.default.createElement(CustomText_1.default, { style: styles.articleTitle }, data?.title),
            react_1.default.createElement(react_native_1.View, { onLayout: (event) => {
                    setBodyHeight(event.nativeEvent.layout.height + (0, scale_1.scale)(16));
                } },
                !!data?.hash_tags?.length && (react_1.default.createElement(react_native_1.View, { style: styles.hashtagList }, data?.hash_tags?.map((item, index) => (react_1.default.createElement(components_1.HashtagText, { key: index, text: item, style: styles.articleHashtag, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.HASHTAG_DETAIL,
                            params: {
                                hashtag: item,
                                typeScreen: 0,
                                typeHashTag: isArticle ? 1 : 2
                            },
                        });
                    } }))))),
                react_1.default.createElement(react_native_1.View, { style: styles.userInfo },
                    react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
                        react_1.default.createElement(react_native_1.Image, { source: data?.user_thumbnail_url ? { uri: data.user_thumbnail_url } : images_1.images.AvatarDefaul, style: styles.userAvatar })),
                    react_1.default.createElement(react_native_1.View, { style: styles.userInfoDetail },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 1, style: styles.userNickname, onPress: navigateToUserProfile }, data?.user_nickname || constants_1.DEFAULT_NAME),
                        react_1.default.createElement(CustomText_1.default, { style: styles.postTime }, (0, moment_1.default)(data?.posting_datetime).format('YYYY/MM/DD HH:mm')))),
                react_1.default.createElement(components_1.LinearButton, { title: isArticle ? "記事を見る" : '自分史を見る', fontWeight: "600", textStyle: styles.primaryBtnLabel, style: styles.primaryBtn, containerStyle: { marginTop: (0, scale_1.scale)(16) }, onPress: () => {
                        (0, rootNavigation_1.push)(Routes_1.default.DETAIL_STORY, { id: data?.article_id });
                    } })))));
};
const styles = react_native_1.StyleSheet.create({
    box: {
        position: 'absolute',
        bottom: 0,
        width: scale_1.width,
        backgroundColor: '#FEFEFE',
        borderTopLeftRadius: (0, scale_1.scale)(16),
        borderTopRightRadius: (0, scale_1.scale)(16),
        shadowColor: '#0000001A',
        shadowOffset: {
            width: 0,
            height: -(0, scale_1.scale)(4),
        },
        shadowOpacity: 1,
        shadowRadius: (0, scale_1.scale)(12),
        elevation: 6,
    },
    header: {
        width: '100%',
        height: (0, scale_1.scale)(46),
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: (0, scale_1.scale)(16),
        borderBottomWidth: (0, scale_1.scale)(1),
        borderBottomColor: '#DDDDDD',
    },
    headerBtn: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#007AFF'
    },
    headerTitle: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
    body: {
        flex: 1,
        padding: (0, scale_1.scale)(16),
    },
    articleTitle: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33'
    },
    hashtagList: {
        width: '100%',
        marginTop: (0, scale_1.scale)(12),
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: (0, scale_1.scale)(8)
    },
    articleHashtag: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#007AFF',
    },
    userInfo: {
        width: '100%',
        marginTop: (0, scale_1.scale)(12),
        flexDirection: 'row'
    },
    userAvatar: {
        width: (0, scale_1.scale)(30),
        height: (0, scale_1.scale)(30),
        borderRadius: 999,
    },
    userInfoDetail: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        // justifyContent: 'space-between',
        marginLeft: (0, scale_1.scale)(12),
    },
    userNickname: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    postTime: {
        marginLeft: (0, scale_1.scale)(12),
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888'
    },
    primaryBtn: {
        width: '100%',
        height: (0, scale_1.scale)(48),
        borderRadius: (0, scale_1.scale)(4)
    },
    primaryBtnLabel: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#FEFEFE'
    }
});
exports.default = ArticleInfo;
